import { getData } from '../assets/scripts/GeneralFunctions'
import { LazyCustomersResponse } from './CustomersResponse'

export const customerSearchApi = (
  search_value,
  customers,
  customersType,
  setCustomerTypeListItem
) => {
  const list = search_value
    ? customers.filter(({ mobile }) => mobile.toLowerCase().includes(search_value.toLowerCase()))
    : customers
  LazyCustomersResponse(list, customersType, setCustomerTypeListItem)
}

export const mainSearchApiHandler = async (
  search_value,
  is_all_items_load,
  lazy_load_data,
  setLazyLoadData,
  setIsSearch,
  setCars,
  searchResult,
  period
) => {
  const api_result = await paramsHandler(search_value, setIsSearch, 'admin/cars', null, period)
  if (api_result) {
    setIsSearch(false)
    if (api_result?.status === 200) {
      if (search_value?.length > 0) {
        setLazyLoadData({
          ...lazy_load_data,
          search: search_value,
        })
      }
      setIsSearch(true)
      setCars(api_result?.data?.cars)
      searchResult(api_result?.data?.cars)
    }
  }
}

export const productsSearchApi = async (
  search_value,
  setAllLoad,
  is_all_items_load,
  lazy_load_data,
  setLazyLoadData,
  setProducts,
  searchResult
) => {
  const api_result = await paramsHandler(
    search_value,
    null,
    'admin/site-options/products',
    lazy_load_data
  )
  if (api_result) {
    if (api_result?.status === 200) {
      if (search_value?.length > 0) {
        setLazyLoadData({
          ...lazy_load_data,
          search: search_value,
        })
      }
      setProducts(api_result?.data?.products)
      searchResult(api_result?.data?.products)
    }
  }
}

const paramsHandler = async (search_value, setIsSearch, url, lazy_load_data, period) => {
  let queryParams = {
    search: search_value,
    ...lazy_load_data,
  }

  if (period[0] && period[1]) {
    queryParams = {
      ...queryParams,
      start: period[0],
      end: period[1],
    }
  }

  if (!search_value?.length) {
    delete queryParams.search
  }

  setIsSearch && setIsSearch(true)

  return await getData(url, 'get', { ...queryParams }, true)
}
